<template>
  <div class="d-flex flex-column flex-md-row flex-nowrap">
      <div class="locked-game d-flex justify-content-center" :key="lockedGame" v-for="lockedGame in totalLockedGame">
           <img  src="../assets/images/closed-game-lock.webp" alt="">
      </div> 
  </div>
</template>

<script>
export default {
    name:'locked-games',
    props:{
        totalLockedGame: {
            default : 0,
            type: Number
        }
    },
    data(){
        return{

        }
    }
}
</script>

<style>
.locked-game{
    background-image: url('../assets/images/closed-game-background.webp');
    background-size: 330px 640px;
    background-repeat: no-repeat;
    width: 330px;
    height: 640px;
    position: relative;
    margin: 37px 21px;
}
.locked-game img{
    position: absolute;
    width:170px;
    height:170px;
    top: 50%;
    transform: translateY(-50%);
}
@media (max-width : 1600px) {
    .locked-game{
        background-size: 278px 478px;
        width: 278px;
        height: 478px;
    }
    .locked-game img{
        width: 113px;
        height: 113px;
    }
}
@media (max-width : 1250px) {
    .locked-game{
        background-size: 180px 290px;
        width: 180px;
        height: 290px;
    }
    .locked-game img{
        width: 80px;
        height: 80px;
    }
}
@media (max-width:780px) {
    .locked-game {
        margin: 37px auto !important;
    }
    .locked-game{
        background-size: 268px 478px;
        width: 268px;
        height: 478px;
    }
    .locked-game img{
        width: 113px;
        height: 113px;
    }
}
@media (max-width:410px) {
    
}
</style>